import { FormControl, FormHelperText, FormLabel } from "@/components/essentials/form-control";
import { Input } from "@/components/essentials/input";
import { type StackProps } from "@chakra-ui/react";
import { type FC } from "react";
import { useFormContext } from "react-hook-form";
import { passwordFormHelperTextSigninTestId, passwordFormInputTestId, passwordFormLabelTestId } from "./const";
import { type PasswordFormValue } from "./type";

export interface PasswordFormProps extends StackProps {
  formLabel?: string;
  helperText?: string;
}

export const PasswordForm: FC<PasswordFormProps> = ({ formLabel, helperText, placeholder, ...rest }) => {
  const {
    register,
    formState: { dirtyFields, errors },
  } = useFormContext<PasswordFormValue>();

  return (
    <FormControl
      id="password"
      isRequired
      isDirty={dirtyFields.password !== undefined}
      isInvalid={errors.password !== undefined}
    >
      <FormLabel data-testid={passwordFormLabelTestId}>{formLabel ?? "パスワード"}</FormLabel>
      <Input
        id="current-password"
        data-testid={passwordFormInputTestId}
        autoComplete="current-password"
        placeholder={placeholder ?? "パスワードを入力してください"}
        {...register("password", {
          required: true,
        })}
        {...rest}
        invisible
      />
      <FormHelperText data-testid={passwordFormHelperTextSigninTestId}>
        {helperText ?? "パスワードを入力してください"}
      </FormHelperText>
    </FormControl>
  );
};
